import { Link } from 'react-router-dom';

const adminPages = [
  {
    section: 'Platform Management',
    items: [
      { path: '/admin/tenants', title: 'Tenants', description: 'Manage V2 customers, subscriptions, seat limits', icon: 'TEN' },
      { path: '/admin/prompts', title: 'AI Prompts', description: 'Edit LLM task configs and prompt versions', icon: 'AI' },
      { path: '/admin/ports', title: 'Port Catalogue', description: 'UN/LOCODE registry used by chat extraction and the new quote form', icon: 'PRT' },
      { path: '/admin/ai-observability', title: 'AI Observability', description: 'Audit chat reasoning + LLM call history (prompts, tokens, latency)', icon: 'OBS' }
    ]
  },
  {
    section: 'Configuration',
    items: [
      { path: '/admin/trucking-parameters', title: 'Trucking Parameters', description: 'Base rates, cost per mile, fuel surcharges', icon: 'TRK' },
      { path: '/admin/duty-rates', title: 'Duty Rates', description: 'Import duty rates by HS code and origin', icon: 'DTY' },
      { path: '/admin/forwarder-rates', title: 'Forwarder Rates', description: 'Ocean freight rates from forwarders', icon: 'FWD' },
      { path: '/admin/customer-drayage', title: 'Customer Drayage', description: 'Last-mile delivery cost parameters', icon: 'DRG' },
      { path: '/admin/us-customs', title: 'US Customs', description: 'US customs rules and tariff configurations', icon: 'CUS' }
    ]
  },
  {
    section: 'Estimates',
    items: [
      { path: '/admin/estimate-calculator', title: 'Estimate Calculator', description: 'Create standalone freight estimates with locked price', icon: 'EST' },
      { path: '/admin/estimate-config', title: 'Estimate Config', description: 'Manage price multiplier and estimate settings', icon: 'CFG' }
    ]
  },
  {
    section: 'V3 Features',
    items: [
      { path: '/admin/hs-codes', title: 'HS Codes', description: 'Lookup and manage HS code registry', icon: 'HS' },
      { path: '/admin/fuel-costs', title: 'Fuel Costs', description: 'Regional fuel price index and updates', icon: 'FUEL' },
      { path: '/admin/writeback', title: 'Write-Back Logs', description: 'Monitor DB write-back operations', icon: 'WB' },
      { path: '/admin/setup', title: 'Test Data Setup', description: 'Seed test data for V3 features', icon: 'SET' }
    ]
  }
];

const AdminHub = () => {
  return (
    <div className="admin-hub">
      <div className="page-header">
        <h1>Admin Settings</h1>
      </div>
      {adminPages.map(section => (
        <div key={section.section} className="admin-section">
          <h2 className="admin-section-title">{section.section}</h2>
          <div className="admin-grid">
            {section.items.map(item => (
              <Link key={item.path} to={item.path} className="admin-card">
                <div className="admin-card-icon">{item.icon}</div>
                <div className="admin-card-content">
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AdminHub;
